/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import Buttons from "../../../components/ui/button/Buttons";
import { useNavigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
/** Common Components */
import CardSection from "../../../components/ui/card/CardSection";
import FormCreator from "../../../components/finalForms/FormCreator";
/** RTK Query */
import {
  useAddProjectMutation,
  useLazyGetAllCustomerQuery,
  useLazyGetProjectByIdQuery,
  useLazyGetProjectDomainQuery,
  useLazyGetProjectTypesQuery,
  useLazyGetUserListQuery,
  useUpdateProjectMutation,
} from "../../../app/services/projectManagementAPI";
/** Common Services & Data Files */
import ToastService from "../../../services/toastService/ToastService";
import { decryptUrlData } from "../../../services/CryptoService";
import { setProjectData } from "../../../app/slice/projectSlice";
import { mapDropdownOptions } from "../../../components/finalForms/libs/mapDropdownOptions";
import projectsFormData from "../config/Project.data";
import RenderTabs from "../../../components/ui/tabs/RenderTabs";
import ProjectTeam from "./projectTabs/projectTeam/ProjectTeam"
import ProjectStatusTest from "./projectStatusTest/ProjectStatusTest";

const ProjectsForm = (props) => {
  const projectRef = useRef();
  const dispath = useDispatch();
  const { id } = useParams();
  let projectId = null;
  let projectName = null;
  let projectCode = null;
  const projectIdData = id ? decryptUrlData(id) : 0;
  if (typeof projectIdData === "object" && projectIdData !== null) {
    projectId = projectIdData.projectId;
    projectCode = projectIdData.projectCode;
    projectName = projectIdData.projectName;
  } else if (projectIdData) {
    projectId = projectIdData;
  }
  const navigate = useNavigate();
  /* State*/
  const [shouldRerenderFormCreator, setShouldRerenderFormCreator] = useState(false);
  const [projectForm, setProjectForm] = useState(projectsFormData);
  const [projectname, setprojectName] = useState("");
  const [projectcode, setprojectCode] = useState("Projects");
  const organizationId = useSelector((state) => state.auth.user.organizationId);

  const tabs = [
    {
      sMenuItemCaption: `Project Team`,
      icon: "",
      component: <ProjectTeam projectId={projectId} />,
    },
    {
      sMenuItemCaption: "Project Status",
      icon: "",
      component: <ProjectStatusTest projectId={projectId} />,
    },
  ];
  // API'S Call
  const [addProject, {
    isLoading: isProjectAddding,
    isSuccess: isSucessAddProject,
    data: addProjectData,
  },] = useAddProjectMutation();

  const [updateProject, {
    isLoading: updateProjectLoading,
    isSuccess: isSuccessUpdateProject,
    data: updateProjectData,
  },] = useUpdateProjectMutation();

  const [getProjectDomain, {
    isFetching: isProjectDomainFetching,
    isSuccess: isProjectDomain,
    data: ProjectDomainData,
  },] = useLazyGetProjectDomainQuery();

  const [getProjectTypes, {
    isFetching: isProjectTypesFetching,
    isSuccess: isProjectTypes,
    data: ProjectTypesData,
  },] = useLazyGetProjectTypesQuery();

  const [getAllCustomer, {
    isFetching: isAllCustomerFetching,
    isSuccess: isAllCustomer,
    data: allCustomerData,
  },] = useLazyGetAllCustomerQuery();

  const [getUserList, {
    isFetching: isUserNameFetching,
    isSuccess: isUserName,
    data: UserNameData,
  },] = useLazyGetUserListQuery();

  const [getProjectById, {
    isFetching: isGetProjectByIdFetching,
    isSuccess: isGeProjecttByIdSuccess,
    data: isGetProjectByIdData,
  },] = useLazyGetProjectByIdQuery();

  //** useEffect's */
  useEffect(() => {
    getProjectDomain();
    getProjectTypes();
    getAllCustomer();
    getUserList();
  }, []);

  useEffect(() => {
    if (isSuccessUpdateProject && updateProjectData) {
      backToList();
      ToastService.success(updateProjectData.errorMessage);
    }
  }, [isSuccessUpdateProject, updateProjectData]);

  useEffect(() => {
    if (
      isGeProjecttByIdSuccess &&
      !isGetProjectByIdFetching &&
      isGetProjectByIdData
    ) {
      if (isGetProjectByIdData) {
        let formData = { ...projectForm };
        formData.initialState = {
          ...projectForm.initialState,
          OrganizationId: organizationId,
          projectName: isGetProjectByIdData.projectName,
          projectCode: isGetProjectByIdData.projectCode,
          customerId: isGetProjectByIdData.customerId,
          responsibleUser: isGetProjectByIdData.responsibleUser,
          projectStartDate: new Date(isGetProjectByIdData.projectStartDate),
          projectEndDate: isGetProjectByIdData.projectEndDate
            ? new Date(isGetProjectByIdData.projectEndDate)
            : null,
          billingCycleStartDate: isGetProjectByIdData.billingCycleStartdate,
          projectDomainId: isGetProjectByIdData.projectDomainId,
          projectTypeId: isGetProjectByIdData.projectTypeId,
          description: isGetProjectByIdData.description,
          isActive: isGetProjectByIdData.isActive,
          isRequireTimeSheetApproval:
            isGetProjectByIdData.isRequireTimesheetApproval,
        };
        setprojectName(formData?.initialState?.projectName);
        setprojectCode(formData.initialState.projectCode)
        setProjectForm(formData);
        setShouldRerenderFormCreator((prevState) => !prevState);
        dispath(setProjectData(isGetProjectByIdData));
      }
    }
  }, [isGeProjecttByIdSuccess, isGetProjectByIdFetching, isGetProjectByIdData]);

  useEffect(() => {
    onreset();
    if (projectId) {
      getProjectById(projectId);
    }
  }, [projectId, getProjectById]);

  useEffect(() => {
    if (isProjectDomain && !isProjectDomainFetching && ProjectDomainData) {
      mapDropdownOptions(
        projectsFormData,
        "projectForm",
        "projectDomainId",
        ProjectDomainData,
        "projectDomainId",
        "projectDomainName"
      );
    }
  }, [isProjectDomain, isProjectDomainFetching, ProjectDomainData]);

  useEffect(() => {
    if (isAllCustomer && !isAllCustomerFetching && allCustomerData) {
      mapDropdownOptions(
        projectsFormData,
        "projectForm",
        "customerId",
        allCustomerData,
        "customerId",
        "customerName"
      );
    }
  }, [isAllCustomer, isAllCustomerFetching, allCustomerData]);

  useEffect(() => {
    if (isProjectTypes && !isProjectTypesFetching && ProjectTypesData) {
      mapDropdownOptions(
        projectsFormData,
        "projectForm",
        "projectTypeId",
        ProjectTypesData,
        "projectTypeId",
        "projectTypeName"
      );
    }
  }, [isProjectTypes, isProjectTypesFetching, ProjectTypesData]);

  useEffect(() => {
    if (isUserName && !isUserNameFetching && UserNameData) {
      mapDropdownOptions(
        projectsFormData,
        "projectForm",
        "responsibleUser",
        UserNameData,
        "userId",
        "userName"
      );
    }
  }, [isUserName, isUserNameFetching, UserNameData]);

  useEffect(() => {
    if (isSucessAddProject && addProjectData) {
      if (props.onSuccess) {
        props.onSuccess();
      }
      onreset();
      backToList();
      ToastService.success(addProjectData.errorMessage);
    }
  }, [isSucessAddProject, addProjectData, props]);

  //** Funcation's */
  const handleSubmit = () => {
    const ProjectsData = projectRef.current.getFormData();
    if (ProjectsData && !projectId) {
      const requestData = {
        ...ProjectsData,
        customerId:
          ProjectsData.customerId && typeof ProjectsData.customerId === "object"
            ? ProjectsData.customerId.value
            : ProjectsData.customerId,
        OrganizationId: organizationId,
        responsibleUser:
          ProjectsData.responsibleUser &&
            typeof ProjectsData.responsibleUser === "object"
            ? ProjectsData.responsibleUser.value
            : ProjectsData.responsibleUser,
        projectDomainId:
          ProjectsData.projectDomainId &&
            typeof ProjectsData.projectDomainId === "object"
            ? ProjectsData.projectDomainId.value
            : ProjectsData.projectDomainId,
        projectTypeId:
          ProjectsData.projectTypeId &&
            typeof ProjectsData.projectTypeId === "object"
            ? ProjectsData.projectTypeId.value
            : ProjectsData.projectTypeId,
      };
      if (ProjectsData.projectEndDate < ProjectsData.projectStartDate) {
        ToastService.error("End date cannot be before start date");
        return;
      }
      addProject(requestData);
    } else if (projectId && ProjectsData) {
      const RequstUpdateData = {
        projectId: projectId,
        projectName: ProjectsData.projectName,
        projectCode: ProjectsData.projectCode,
        customerId:
          ProjectsData.customerId && typeof ProjectsData.customerId === "object"
            ? ProjectsData.customerId.value
            : ProjectsData.customerId,

        responsibleUser:
          ProjectsData.responsibleUser &&
            typeof ProjectsData.responsibleUser === "object"
            ? ProjectsData.responsibleUser.value
            : ProjectsData.responsibleUser,

        projectStartDate: ProjectsData.projectStartDate,
        projectEndDate: ProjectsData.projectEndDate
          ? ProjectsData.projectEndDate
          : null,

        billingCycleStartDate: ProjectsForm.billingCycleStartDate,

        projectDomainId:
          ProjectsData.projectDomainId &&
            typeof ProjectsData.projectDomainId === "object"
            ? ProjectsData.projectDomainId.value
            : ProjectsData.projectDomainId,

        projectTypeId:
          ProjectsData.projectTypeId &&
            typeof ProjectsData.projectTypeId === "object"
            ? ProjectsData.projectTypeId.value
            : ProjectsData.projectTypeId,

        description: ProjectsData.description,
        isActive: ProjectsData.isActive,
        isRequireTimeheetApproval: ProjectsData.isRequireTimeSheetApproval,
      };
      updateProject(RequstUpdateData);
    }
  };
  const onreset = () => {
    let projectformData = { ...projectsFormData };
    projectformData.initialState = { ...props.initData, isActive: true };
    setProjectForm(projectformData);
    setShouldRerenderFormCreator((prevState) => !prevState);
  };

  const backToList = () => {
    navigate("/admin/projects");
  };

  const handleProjectNameChange = (name) => {
    if (!name || typeof name !== "string") return;

    const generatedCode = generateProjectCode(name.trim());
    setprojectName(name);
    setprojectCode(generatedCode); // Update project code state

    setProjectForm((prevForm) => ({
      ...prevForm,
      initialState: {
        ...prevForm.initialState,
        projectName: name,
        projectCode: generatedCode, // Set project code in form
      },
    }));
  };

  const generateProjectCode = (name) => {
    if (!name || typeof name !== "string") return "";

    name = name.trim();
    if (!name) return "";

    const words = name.split(/[\s\-/]+/).filter(Boolean); // Split by spaces, hyphens, or slashes

    let code =
      words.length === 1
        ? words[0].substring(0, 3).toUpperCase() // Single word → first 3 letters
        : words.map((word) => word[0].toUpperCase()).join(""); // Multi-word → initials

    return code;
  };

  return (
    <div className="project-info center-top-space">
      <CardSection
        isContentLoading={
          isProjectAddding ||
          updateProjectLoading ||
          isProjectDomainFetching ||
          isProjectTypesFetching ||
          isAllCustomerFetching ||
          isUserNameFetching ||
          isGetProjectByIdFetching
        }
        cardTitle={
          projectCode ? `${projectCode} - ${projectName}` : projectName
        }
        buttonClassName="dark-btn"
      >
        <form>
          <div className="row mt-0 edit-project-form">
            <FormCreator
              config={projectForm}
              ref={projectRef}
              key={shouldRerenderFormCreator}
              {...projectForm}
              onColumnChange={(field, value) => {

                if (field === "projectName") {
                  const projectName = value?.projectName || ""; // Extract name safely
                  handleProjectNameChange(projectName);
                }

              }}
            />
          </div>
        </form>
        <div className="d-flex justify-content-end">
          <Buttons
            buttonTypeClassName="dark-btn"
            buttonText="Cancel"
            onClick={backToList}
          />
          <Buttons
            buttonTypeClassName="theme-btn ml-4"
            buttonText={`${projectId ? "Update" : "Add"}`}
            isLoading={isProjectAddding || updateProjectLoading}
            onClick={handleSubmit}
          />
        </div>
      </CardSection>
      {projectId && (
        <div className="project-additional-section">
          <RenderTabs tabs={tabs} />
        </div>
      )}

    </div>
  );
};

ProjectsForm.propTypes = {
  initData: PropTypes.shape({
    projectName: PropTypes.string,
    projectCode: PropTypes.string,
    customerId: PropTypes.number,
    responsibleUser: PropTypes.number,
    projectStartDate: PropTypes.instanceOf(Date),
    projectEndDate: PropTypes.instanceOf(Date),
    billingCycleStartDate: PropTypes.number,
    projectDomainId: PropTypes.number,
    projectTypeId: PropTypes.number,
    description: PropTypes.string,
    isActive: PropTypes.bool,
    isRequireTimeSheetApproval: PropTypes.bool,
  }),
  onSuccess: PropTypes.func,
};
export default ProjectsForm;